import Loading from '../../../Common/Loading';
import { AnualEvolution } from './AnualEvolution';
import { HealthScheduleAnual } from './HealthScheduleAnual';
import { HealthScheduleMonthly } from './HealthScheduleMonthly';
import { MonthlyEvolution } from './MonthlyEvolution';
import { RegistrationUpdatesAnual } from './RegistrationUpdatesAnual';
import { RegistrationUpdatesMonthly } from './RegistrationUpdatesMonthly';
import { SchoolAttendanceAnual } from './SchoolAttendanceAnual';
import { SchoolAttendanceMonthly } from './SchoolAttendanceMonthly';
import { useIgdChartsDataContext } from './hooks/useIgdChartsDataContext';
import './styles/Charts.css';

export const Charts = () => {
    const { isLoading } = useIgdChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="chats-indicators-side-by-side-dashboards">
                <AnualEvolution />
                <MonthlyEvolution />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <SchoolAttendanceAnual />
                <SchoolAttendanceMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <HealthScheduleAnual />
                <HealthScheduleMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <RegistrationUpdatesAnual />
                <RegistrationUpdatesMonthly />
            </div>
        </>
    );
};
